import React, { FC, useRef } from 'react';
import type { HomePostHeroProps } from '@/types';
import { TextCols } from '../text-cols';
import { useInView } from '@/hooks/reveal-in-view';

export const HomePostHero: FC<HomePostHeroProps> = ({ title, cols }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="homePostHero">
      <div className="wrapper">
        <TextCols content={cols} />
        <h2
          ref={ref}
          dangerouslySetInnerHTML={{ __html: title.replace(/\n/g, '<br>') }}
          className="homePostHero--title"
          style={{
            transform: isInView ? 'none' : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
          }}
        />
      </div>
    </section>
  );
};
